import { createSlice } from '@reduxjs/toolkit';
import { resetAll } from '../../../../shared/infra/redux/baseActions';
import { ReduxStatus } from '../../../../shared/types';
import { updateContactPermission } from './operators';

export interface SettingsState {
  updateContactPermissionStatus: {
    status: ReduxStatus;
    error: string | null;
  };
}

const initialState: SettingsState = {
  updateContactPermissionStatus: {
    status: 'idle',
    error: null,
  },
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateContactPermission.pending, (state) => {
      state.updateContactPermissionStatus = {
        status: 'loading',
        error: null,
      };
    });
    builder.addCase(updateContactPermission.fulfilled, (state) => {
      state.updateContactPermissionStatus = {
        status: 'success',
        error: null,
      };
    });
    builder.addCase(updateContactPermission.rejected, (state, { payload }) => {
      state.updateContactPermissionStatus = {
        status: 'failure',
        error: payload?.message
          ? payload.message
          : 'Error trying to update contact permissions',
      };
    });
    builder.addCase(resetAll, () => initialState);
  },
});

export default settingsSlice.reducer;
